import React, { Component } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import _ from "lodash";

// constants
import LocaleStrings from "Languages";

class CopyVisit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      copied: false,
    };
  }

  copyUrl = () => {
    this.setState({ copied: true });
    if (!_.isEmpty(this.props.elementId)) this.handleButtonClick();

    setTimeout(() => {
      this.setState({ copied: false });
    }, 500);
  };

  handleButtonClick = () => {
    const range = document.createRange();
    const node = document.getElementById(this.props.elementId);
    range.selectNodeContents(node);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
  };

  render() {
    const {
      elementId = false, // only needed if you want to have the 'text select' effect
      title,
      subtitle = "",
      embed = false, // iframe or not
      link, // actual link
      readonly = false, // if no onChange is present and just to render the link
    } = this.props;

    return (
      <div className="ticket-dashboard-ticket-created-page-main-div">
        <h4 className="heading-para">{title}</h4>

        {!_.isEmpty(subtitle) ? (
          <>
            <p className="promote-para">{subtitle}</p>
          </>
        ) : (
          ""
        )}

        <div className="row">
          <div className="col-md-12">
            <div className="integration-details-page">
              <div className="pb-5">
                {embed
                  ? LocaleStrings.integration_common_type_embed
                  : LocaleStrings.integration_common_type_url}
              </div>
              <div className="integration-details-page-box">
                <textarea
                  id={elementId}
                  className="common_integration_ticket_url"
                  style={embed ? { width: "92%" } : {}}
                  value={link}
                  readOnly={readonly}
                ></textarea>
                <CopyToClipboard text={link} onCopy={this.copyUrl}>
                  <div
                    className={
                      this.state.copied
                        ? "integration_url_copy_selected"
                        : "integration_url_copy"
                    }
                  >
                    {this.state.copied ? (
                      <img
                        src="../../style/images/integration/int_copy_copied.svg"
                        alt="this link has already been copied"
                      />
                    ) : (
                      <img
                        src="../../style/images/integration/int_copy.svg"
                        alt="copy this link"
                      />
                    )}
                  </div>
                </CopyToClipboard>

                {!embed ? (
                  <>
                    <div className="integration_url_visit">
                      <a
                        href={link}
                        target="blank"
                        className="integration_url_visit_hyper"
                        style={{ textDecoration: "none" }}
                      >
                        <span
                          aria-hidden="true"
                          className="custom-text1-secondary-medium"
                        >
                          {LocaleStrings.button_visit}
                        </span>
                        <img
                          src="../../style/images/integration/visit.svg"
                          alt="visit the link on your browser"
                        />
                      </a>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CopyVisit;
